import { SaveEvent } from './SaveEvent';

export type Mutations = {
  SaveEvent: typeof SaveEvent;
};

export const mutations: Mutations = {
  SaveEvent,
};
